import React, { useEffect, useState } from 'react';
import { ActivationPremiumBenefitsProps } from '../types/CodeInfo';
import Icon from '../../common/components/Icon';
import { useTranslations } from '../../localization/useTranslations';

const ActivationPremiumBenefits: React.FC<ActivationPremiumBenefitsProps> = ({ featureCodes }) => {
  const [digitalSections, setDigitalSections] = useState<any[]>([]);
  const translations = useTranslations();

  useEffect(() => {
    if (window.forbes_sales_funnel && window.forbes_sales_funnel.list_of_features) {
      const updatedDigitalSections = window.forbes_sales_funnel.list_of_features.map((feature, index) => ({
        button_label: feature.button_label,
        button_url: feature.button_url,
        feature_code: feature.feature_code,
        feature_description: feature.feature_description,
        feature_icon: feature.feature_icon,
        feature_name: feature.feature_name,
        isVisible: featureCodes.includes(feature.feature_code),
      }));
      setDigitalSections(updatedDigitalSections);
    }
  }, [featureCodes]);

  // Check if any section is visible
  const anySectionVisible = digitalSections.some((section) => section.isVisible);

  return (
    <>
      {anySectionVisible && (
        <div className="section section--benefits">
          <h4 className="section__title">
            {translations?.paymentBenefits?.premiumBenefitsTitle || 'Benefity Forbes Premium'}
          </h4>

          <div className="section__wrapper benefits-wrapper">
            {digitalSections
              .filter((section) => section.isVisible)
              .map(({ button_label, button_url, feature_code, feature_description, feature_icon, feature_name }) => (
                <div
                  className={`benefit-card benefit-card--${feature_icon}`}
                  id={feature_code}
                  key={feature_code} // Add a unique key for each item in the list
                >
                  <span className="benefit-card__icon"></span>

                  <div className="benefit-card__content">
                    <h5 className="benefit-card__subtitle">{feature_name}</h5>
                    <div className="benefit-card__description">
                      <div
                        dangerouslySetInnerHTML={{
                          __html: feature_description,
                        }}
                      ></div>
                    </div>

                    {feature_code === 'forbesArchive' && (
                      <>
                        <div className="link-wrapper">
                          <div>
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={
                                translations?.paymentBenefits?.premiumBenefitsAppStoreUrl ||
                                'https://apps.apple.com/cz/app/forbes-%C4%8Desko/id920787573'
                              }
                              className="section__link section__link--download link--icon link__icon--before link link--medium"
                            >
                              <Icon name="apple" size="small" />
                              {translations?.paymentBenefits?.premiumBenefitsAppStore || 'Download from the App Store'}
                            </a>
                          </div>
                          <div>
                            <a
                              target="_blank"
                              rel="noopener noreferrer"
                              href={
                                translations?.paymentBenefits?.premiumBenefitsGooglePlayUrl ||
                                'https://play.google.com/store/apps/details?id=cz.mediarey.forbes&hl=en_ZA'
                              }
                              className="section__link section__link--download link--icon link__icon--before link link--medium"
                            >
                              <Icon name="google-play" size="small" />
                              {translations?.paymentBenefits?.premiumBenefitsGooglePlay || 'Download from Google Play'}
                            </a>
                          </div>
                        </div>
                      </>
                    )}

                    {button_url && button_label && (
                      <a href={button_url} className="benefit-card__link link">
                        {button_label}
                      </a>
                    )}
                  </div>
                </div>
              ))}
          </div>
        </div>
      )}
    </>
  );
};

export default ActivationPremiumBenefits;
